import { IComponent } from 'src/generated-types'
import { queryClient, usePost, usePut } from '@lovoldsystem/core.client'
import { useGet } from './reactQuery'
import { IPaginatedResult } from './paginated-result'
import { apiConsts } from './apiConsts'
import { IUpdateComponentQty } from 'src/generated-types/component-quantity'

const baseUrl = (customerId: EntityId, positionId?: EntityId) =>
  positionId
    ? `customers/${customerId}/projectpositions/${positionId}/projectcomponents`
    : `customers/${customerId}/projectcomponents`

export const projectComponentEndpoints = {
  getComponents(customerId: EntityId, positionId: EntityId) {
    return `${baseUrl(customerId, positionId)}`
  },
  getComponent(customerId: EntityId, positionId: EntityId, id: EntityId) {
    return `${baseUrl(customerId, positionId)}/${id}`
  },
  createComponent(customerId: EntityId, positionId: EntityId) {
    return `${baseUrl(customerId, positionId)}`
  },
  updateComponent(customerId: EntityId, positionId: EntityId) {
    return `${baseUrl(customerId, positionId)}`
  },
  UpdateComponentQty(customerId: EntityId, positionId: EntityId) {
    return `${baseUrl(customerId, positionId)}/update-quantity`
  },
}

export const invalidateProjectComponentCache = {
  getComponents(customerId: EntityId, positionId: EntityId) {
    return queryClient.invalidateQueries(projectComponentEndpoints.getComponents(customerId, positionId))
  },
  getComponent(customerId: EntityId, positionId: EntityId, id: EntityId) {
    return queryClient.invalidateQueries(projectComponentEndpoints.getComponent(customerId, positionId, id))
  },
}

export const useGetProjectComponents = (
  customerId: EntityId,
  positionId: EntityId,
  page: number = apiConsts.Page,
  pageSize: number = apiConsts.PageSize,
  enabled = true,
) => {
  return useGet<IPaginatedResult<IComponent>>(
    projectComponentEndpoints.getComponents(customerId, positionId),
    {
      page,
      pageSize,
    },
    { enabled: !!positionId && enabled },
  )
}

export const useGetProjectComponent = (customerId: EntityId, positionId: EntityId, id: EntityId) =>
  useGet<IComponent>(projectComponentEndpoints.getComponent(customerId, positionId, id), {})

export const useAddProjectComponent = (customerId: EntityId, positionId: EntityId) =>
  usePost<IComponent, IComponent>(projectComponentEndpoints.createComponent(customerId, positionId))

export const useUpdateProjectComponent = (customerId: EntityId, positionId: EntityId) =>
  usePut<IComponent, IComponent>(projectComponentEndpoints.updateComponent(customerId, positionId))

export const useUpdateComponentQty = (customerId: EntityId, positionId: EntityId) =>
  usePut<IUpdateComponentQty, IUpdateComponentQty>(projectComponentEndpoints.UpdateComponentQty(customerId, positionId))
